module.exports = __webpack_public_path__ + "static/media/19ESCAP35.aa19c2ba.jpg";